import type { AppState, AppAction } from '../appReducerTypes';

export function forYouReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case 'SET_FOR_YOU_ITEMS':
      return { ...state, forYouItems: action.payload };
    case 'ADD_FOR_YOU_ITEM':
      if (state.forYouItems.some((item) => item.id === action.payload.id)) {
        return state;
      }
      return {
        ...state,
        forYouItems: [action.payload, ...state.forYouItems],
      };
    case 'REMOVE_FOR_YOU_ITEM':
      return {
        ...state,
        forYouItems: state.forYouItems.filter((item) => item.id !== action.payload),
      };
    case 'REORDER_FOR_YOU_ITEMS':
      return { ...state, forYouItems: action.payload };
    default:
      return state;
  }
}
